import { Component, Input, inject, HostAttributeToken } from '@angular/core';
import { slideAnimation } from '../../detailview/slide.animation';
import { DomSanitizer } from '@angular/platform-browser';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';

import { ClarityModule } from '@clr/angular';
import { FileForMediaView, MediaViewModalComponent } from '../mediaviewmodal/mediaviewmodal.component';
import { FileForPreview } from '../preview-thumbnails/preview-thumbnail.type';

@Component({
  selector: 'app-image-slide-show',
  templateUrl: './image-slide-show.component.html',
  styleUrls: ['./image-slide-show.component.scss'],
  imports: [ClarityModule, MediaViewModalComponent],
  animations: [slideAnimation],
})
export class ImageSlideShowComponent {
  private domSanitizer = inject(DomSanitizer);
  protected readonly height = inject(new HostAttributeToken('height'), {
    optional: true,
  });
  protected readonly invert = inject(new HostAttributeToken('invert'), {
    optional: true,
  });

  protected currentIndex: number = 0;
  protected currentThumb: any;
  protected previewThumbnails: any[];
  protected files: FileForPreview[];

  protected imageMedia: FileForMediaView;

  @Input() set data(files: FileForPreview[]) {
    this.files = files;
    this.previewThumbnails = files?.map(f => {
      const extension = f.extension ?? f.name?.split('.').pop();
      const type = 'data:image/' + (extension == 'svg' ? 'svg+xml' : extension || 'png');
      return this.domSanitizer.bypassSecurityTrustUrl(type + ';base64,' + f.base64);
    });
    this.changeIndexTo(0);
  }

  imagezoom() {
    this.imageMedia = {
      isSkizze: this.invert != null,
      title: this.invert ? 'Messpunktskizze' : 'Passbild',
      files: this.files,
      currentIndex: this.currentIndex,
    };
  }

  protected moveGallery(mode: 'right' | 'left') {
    let nextIndex = this.currentIndex;
    if (mode == 'right') nextIndex++;
    else if (mode == 'left') nextIndex--;

    if (nextIndex >= this.previewThumbnails.length) nextIndex = 0;
    if (nextIndex < 0) nextIndex = this.previewThumbnails.length - 1;

    this.changeIndexTo(nextIndex);
  }

  protected changeIndexTo(index: number) {
    this.currentIndex = index;
    this.currentThumb = this.previewThumbnails?.[index];
  }
}
